import { createCustomAction } from 'typesafe-actions';

import {
  standardEmptyACC,
  standardFailedACC,
  standardFlowACC,
} from '../../utils/sagas';

import { SALE_TYPE } from '../../constants/saleType';

const REQUESTED = '$FETCH_MENU/REQUESTED';
const BLOCKED = '$FETCH_MENU/BLOCKED';
const APPROVED = '$FETCH_MENU/APPROVED';
const SUCCEEDED = '$FETCH_MENU/SUCCEEDED';
const FAILED = '$FETCH_MENU/FAILED';

const request = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      locationId: string;
      saleType: SALE_TYPE;
    }>(type);
};

const succeed = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      menu: Menu;
    }>(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, succeed),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
